import { memo, useCallback, useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from '@languages/index';
import { CAMPAIGN_DTO_ENUMS } from 'api/repositories/campaign/campaign.constants';
import { CampaignDtoEnums } from 'api/repositories/campaign/campaign.types';
import RadioButton from '@components/radioButton';
import CampaignFormField from '../../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { FashionCampaignFormStepTwoContext } from '../../../fashionCampaignFormStepTwo.context';

const OutputTypeField = () => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };
  const { updateCampaignId, campaignFormMethods, storeOrUpdateTemporaryCampaignMutate } =
    useContext(CampaignFormContext);
  const { initPhotoFields } = useContext(FashionCampaignFormStepTwoContext);

  const outputTypeFl = useWatch({
    control: campaignFormMethods.control,
    name: 'outputTypeFl',
  });

  const OUTPUT_TYPES = Object.values(CAMPAIGN_DTO_ENUMS.OUTPUT_TYPE_FL).map((outputType) => ({
    name: outputType === CAMPAIGN_DTO_ENUMS.OUTPUT_TYPE_FL.PHOTO ? languageTexts.photo : languageTexts.reels,
    value: outputType,
  }));

  const onChangeOutputType = useCallback((outputTypeFl: CampaignDtoEnums['OUTPUT_TYPE_FL']) => {
    campaignFormMethods.setValue('outputTypeFl', outputTypeFl);

    // 이미지 관련 form Field 초기화
    initPhotoFields();

    if (!updateCampaignId) {
      storeOrUpdateTemporaryCampaignMutate({
        campaign: {
          outputTypeFl,
        },
      });
    }
  }, []);

  return (
    <CampaignFormField label={`1. ${languageTexts.campaign_form_output_type_field_label}`}>
      <RadioButton
        tabClassName="py-2"
        selectedClassName="py-2 border-black"
        bordered={false}
        options={OUTPUT_TYPES}
        selected={outputTypeFl}
        onSelect={({ value }) => onChangeOutputType(value)}
      />
    </CampaignFormField>
  );
};

export default memo(OutputTypeField);
